import { Grid } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { IsSmallScreen } from "../../commonFunctions/CommonFunctions";
import { breadCrumbsStore } from "../../Components/BreadCrumbs/BreadCrumbsListner";
import ConfirmationPopup, { IMethodAction } from "../../Components/Confirmation/Confirmation";
import { IColumns } from "../../Components/DataGrid/WSDataGrid";
import WSDataGridNew from "../../Components/DataGrid/WSDataGridNew";
import { IOrderColumns } from "../../Components/DataGrid/WSMobileDataGridAdvanced";
import WSFilterButtonGroup from "../../Components/Filter/WSFilterButtonGroup";
import { IHeaderRows } from "../../Components/Filter/WSHeaderFilter";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { resetDataComponent } from "../../StateManagement/actions";

export const CustomerTabList: React.FC<any> = React.memo((props) => {
    const navigate = useNavigate();
    const isMobile = IsSmallScreen();
    const dispatch = useDispatch()
    const { showMessage } = useSnackbar();
    const [action, setAction] = useState<IMethodAction>('DELETE');
    const [apiUrl, setApiUrl] = useState<any>(null);
    const [bodyData, setBodyData] = useState<any>(null);
    const [isPopupOpen, setPopupOpen] = useState(false);
    const [selectedId, setSelectedId] = useState<number | null>(null);
    // AllPermissions.getInstance();
    // const { add, edit, remove, view } = AllPermissions.getUserPermission;
    breadCrumbsStore.updateBreadCrumbs([
        { "Customers": "Customers" }
    ]);
    const filters = ["All Records"];
    const [selectedFilter, setSelectedFilter] = useState(filters[0]);

    const [productSource, setProductSource] = useState<any>({
        url: "Auth/search",
        page: 1,
        pageSize: 10,
        filter: [
            {
                field: "userType",
                operator: "eq",
                value: "customer",
            },
        ],
        sort: [
            {
                "field": "UpdatedAt",
                "direction": "desc"
            }
        ],
    })

    const handleFilter = (value: any) => {
        let soureFilter: any = {
            url: "Auth/search",
            page: 1,
            pageSize: 10,
            filter: [
            ],
            sort: [
                {
                    "field": "UpdatedAt",
                    "direction": "desc"
                }
            ],
        }
        switch (value) {
            case 'In Stock':
                soureFilter.filter = [{
                    "field": "name",
                    "operator": "eq",
                    "value": "In Stock"
                }]
                break

        }
        setProductSource({ ...soureFilter });
    }

    const source = {
        url: "Auth/search",
        page: 1,
        pageSize: 10,
        filter: [
            {
                "field": "userType",
                "operator": "eq",
                "value": "customer"
            }
        ],
        sort: [
            {
                "field": "UpdatedAt",
                "direction": "desc"
            }
        ],
    };

    /**
     * Edit function
     * @param action 
     * @param row 
     */
    const handleAction = async (action: string, row: any) => {
        if (action === "Edit") {
            navigate(`/customer/profile/edit/${row?.id}`)
        }


    };
    const handleStatusClick = async (evt: any, row: any) => {
        navigate(`/customer/profile/add/${row?.id}`)

    };
    const handleConfirm = (response: any) => {
        dispatch(resetDataComponent('customerListGrid'));
        showMessage(response?.message, response?.success ? 'success' : 'error')
    }

    const columns: IColumns[] = [

        {
            header: "Name",
            fieldName: "name",
            type: "default",
            // sortable: true
        },
        {
            header: "Email",
            fieldName: "email",
            tooltip: true,
            type: "default",
        },
        {
            header: "Phone",
            fieldName: "phoneNumber",
            tooltip: true,
            isHide: isMobile,
            type: "default",
        },

        {
            header: "Status",
            fieldName: "status",
            isHide: isMobile,
            isTitleCase: true,
            type: "status",
            showInLineAction: {
                fieldName: 'status',
                valueToCheck: [{ fieldValue: 'Incomplete' }],
                onClick: (e, row) => handleStatusClick(e, row),
                actionString: "Update Profile"
            }
        },



        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: ["Edit"].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),
            hideSelectedActions: {
                fieldToHide: [
                    {
                        field: 'status',
                        hideValue: ['Incomplete'],
                        hideActions: ['Edit']
                    },
                    // {
                    //     field: 'profileStatus',
                    //     hideValue: ['Approved'],
                    //     hideActions: ['Approve']
                    // }
                ]
            }

        },

    ];
    const mobColumns: IOrderColumns[] = [
        {
            header: "Full Name",
            fieldName: "fullName",
            type: "default",
            labelSx: { fontWeight: 'bold' }
        },
        {
            header: "Email",
            fieldName: "email",
            tooltip: true,
            type: "default",
        },
        {
            header: "Phone",
            fieldName: "phoneNumber",
            tooltip: true,

            type: "default",
        },
        {
            header: "Created On",
            fieldName: "createdAt",
            isBoderRadious: true,
            type: "date",
        },
        {
            header: "Updated On",
            fieldName: "updatedAt",
            isBoderRadious: true,
            type: "date",
        },

        {
            header: "Actions",
            fieldName: "actions",
            type: "action",
            actions: ["Edit"].filter(Boolean),
            actionCallback: (action, row) => handleAction(action, row),
        },


    ];

    const transFormData = (data: any) => {
        if (data) {
            data.map((item: any, index: number) => {
                item.fullName = `${item?.firstName} ${item?.lastName ? item?.lastName : ''}`;
                item.status = item?.isProfileComplete === false ? "Incomplete" : "Completed"
                item.profileStatus = item?.isApproved === false ? "Pending" : "Approved"
            })
            return data
        }
    }
    const filterRows: IHeaderRows[] = [
        {
            label: "Status",
            fieldName: "IsProfileComplete",
            type: "dropdown",
            options: [{ label: "Completed", value: "true" }, { label: "Incomplete", value: "false" }],
            operator: 'eq',
            rowDivision: 3
        },
        // {
        //     label: "Category",
        //     fieldName: "IsProfileComplete",
        //     type: "dropdown",
        //     options: [{ label: "Completed", value: "true" }, { label: "Incomplete", value: "false" }],
        //     operator: 'eq',
        //     rowDivision: 3
        // },
        // {
        //     label: "Last Name",
        //     fieldName: "LastName",
        //     type: "date",
        //     operator: 'like',
        //     rowDivision: 6
        // },

    ];
    return (
        <Grid p={0}>
            {/* <Grid container spacing={2}>
                {<Grid item xs={12}>
                    {!isMobile && <WSDataGrid columns={columns}
                        id="customerListGrid"
                        title="Customers"
                        source={source}
                        transFormData={transFormData}
                        filterFields={filterRows}
                        //addButton={{ label: "New", color: "secondary" }}
                        // onAddButtonClick={handleClick}
                        searchBox={{ fieldName: 'name' }}
                        gridHeaderSx={{ backgroundColor: 'whitesmoke', border: '1px solid whitesmoke' }}
                    />
                    }
                    {isMobile &&
                        <WSMobileDataGridAdvanced title={'Users'} addButton={{ label: "New", color: "secondary" }}
                            transFormData={transFormData} columns={mobColumns} id="userListGrid" source={source} />
                    }
                    {apiUrl !== null && <ConfirmationPopup
                        apiUrl={apiUrl}
                        id={selectedId!}
                        confirmMessage="Are you sure you want to continue?"
                        open={isPopupOpen}
                        onClose={() => setPopupOpen(false)}
                        onConfirm={handleConfirm}
                        type={action}
                        bodyData={bodyData}
                    />}
                </Grid>
                }
            </Grid> */}
            <Grid container spacing={2}>
                <Grid item sm={9}>
                    <WSFilterButtonGroup
                        options={filters}
                        selected={selectedFilter}
                        onChange={(value) => {
                            setSelectedFilter(value);
                            handleFilter(value);
                        }}
                    />
                </Grid>

                <Grid item xs={12}>
                    {productSource && (
                        <WSDataGridNew
                            id="customerListGrid"
                            title="Customers"
                            columns={columns}
                            source={productSource}
                            transFormData={transFormData}
                            filterFields={filterRows}
                            searchBox={{ fieldName: "name" }}
                            addButton={{ label: "New", color: "secondary" }}
                            gridHeaderSx={{
                                backgroundColor: "whitesmoke",
                                border: "1px solid whitesmoke",
                            }}
                        />
                    )}
                    {apiUrl !== null && <ConfirmationPopup
                        apiUrl={apiUrl}
                        id={selectedId!}
                        confirmMessage="Are you sure you want to continue?"
                        open={isPopupOpen}
                        onClose={() => setPopupOpen(false)}
                        onConfirm={handleConfirm}
                        type={action}
                        bodyData={bodyData}
                    />}
                </Grid>
            </Grid>
        </Grid>
    )
})